import React, { PureComponent } from 'react';
import { View, Text, TouchableOpacity } from 'react-native';

import { createContainer } from '@dbk-legacy/muster/react';

class LoadingView extends PureComponent {

  componentDidMount() {
    if (this.props.auth.jwt === null || this.props.auth.jwt === "") {
      this.props.changePage("/login")
    }
  }

  render() {
    return (
      <div></div>
    );
  }
}

export default createContainer({
  $queries: {
    changePage: { $call: 'ui.history.push' },
    auth: {
      jwt: true
    }
  },
})(LoadingView);
